import { CONVERSATION_STATES, type ConversationState, SEARCH_MIN_LENGTH } from '@hilo/contracts';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import type { AssignedFilter, InboxFilters } from '../../lib/queries';

const ASSIGNED: AssignedFilter[] = ['all', 'me', 'free'];

/** Los filtros viven en la URL (?conexion=&estado=&asignacion=&buscar=): sobreviven a recargar. */
export function useInboxFilters() {
  const [params, setParams] = useSearchParams();

  const filters = useMemo<InboxFilters & { search: string }>(() => {
    const state = params.get('estado');
    const assigned = params.get('asignacion');
    const search = params.get('buscar') ?? '';
    const q = search.trim();
    return {
      ...(params.get('conexion') ? { connectionId: params.get('conexion')! } : {}),
      ...(state && (CONVERSATION_STATES as readonly string[]).includes(state) ? { state: state as ConversationState } : {}),
      assigned: ASSIGNED.includes(assigned as AssignedFilter) ? (assigned as AssignedFilter) : 'all',
      ...(q.length >= SEARCH_MIN_LENGTH ? { q } : {}),
      search,
    };
  }, [params]);

  const update = useCallback((changes: Record<string, string | null>) => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      for (const [key, value] of Object.entries(changes)) {
        if (value === null || value === '') next.delete(key);
        else next.set(key, value);
      }
      return next;
    }, { replace: true });
  }, [setParams]);

  return { filters, update, search: params.toString() };
}

export function apiFilters(filters: InboxFilters & { search: string }): InboxFilters {
  const { search: _search, ...rest } = filters;
  return rest;
}
